import request from '../utils/request'

export function saveZuopin(data) { // 保存投稿作品
  return request({
    url: '/api/tougaosZuopins/save',
    method: 'POST',
    data
  })
}

export function confirmZuopin(data) { // 确认提交投稿作品
  return request({
    url: '/api/tougaosZuopins/confirm',
    method: 'POST',
    data
  })
}

export function zuopinList(params) { // 作品列表
  return request({
    url: '/api/tougaosZuopins/list',
    method: 'GET',
    params
  })
}

export function zuopinDetail(params) { // 作品详情
  return request({
    url: '/api/tougaosZuopins/detail',
    method: 'GET',
    params
  })
}
